import { ColorsInterface } from './types';

const dark: ColorsInterface = {
    brand: '#ff312c',
    notifications: {
        success: '#10b278',
        warning: '#f3b840',
        error: '#ff312c',
        info: '#007ae5',
    },
    links: {
        accent: '#45b6fc',
        native: '#d6e3f0',
    },
    text: {
        head: '#ffffff',
        primary: '#eef0f6',
        hint: '#9498a1',
        disabled: '#474f5e',
        contrast: '#181b21',
        info: '#5c5e62',
    },
    system: {
        accent: '#dc3935',
        primary: '#a9c1cf',
        secondary: '#232c35',
        disabled: '#232C3566',
        deep: '#E6EEF51A',
        light: '#CCE5FF1A',
        background: '#0D0F13',
    },
    overlay: '#20202099',
};

export default dark;
